import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            // Define a datatable view
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable
            css: 'webix_header_border webix_data_border',
            // Enable row selection
            select: true,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for rating with a unique identifier
                    id: 'rating',
                    // Header is empty for this column
                    header: '',
                    // Width of the column
                    width: 50,
                    // Height of the column
                    height: 25,
                    // Template function to render the cell content
                    template: function (obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('TokenLocalEdit', 'Edit')) {
                            // Return an edit icon if permission is granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            // Return an edit icon if permission is denied (same icon)
                            return "<span class='webix_icon wxi-close edit'></span>";
                        }
                    },
                },
                // Column for date with localization
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                // Column for user with localization
                { id: 'User', header: _('Usuario'), width: 100, sort: 'int' },
                {
                    // Column for type with localization
                    id: 'Type',
                    header: _('Tipo'),
                    width: 100,
                    // Editor type for this column
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: '0', value: _('Local') },
                        { id: '2', value: _('Box') },
                    ],
                    // Sorting type for this column
                    sort: 'int',
                },
                {
                    // Column for state with localization
                    id: 'State',
                    header: _('Estado'),
                    // Editor type for this column
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'E', value: _('Expirado') },
                    ],
                    // Width of the column
                    width: 150,
                    // Sorting type for this column
                    sort: 'int',
                },
                // Column for token code with localization
                { id: 'Token', header: _('Código'), width: 300, sort: 'int' },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit token local dialog
                    $$('edittokenLocal').show();
                },
            },
            // Disable editing for the datatable
            editable: false,
            // Enable mathematical operations in the datatable
            math: true,
            // Load ahead configuration for data fetching
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // URL for fetching user security data, including the current user ID
            url: devConfig.geturlApi() + '/UserManagement/GetUserSecurityL?FromId=' + cur_user + '&',
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);
        // Access the localization service for translation functions
        const _ = this.app.getService('locale')._;
        // Store the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Set up an event listener for the 'generateTokenBetShop:filter' event
        this.on(this.app, 'generateTokenBetShop:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize a string to build the query parameters
            var string1 = '';
            // Iterate through each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date); // Log the date range for debugging
                        // Append dateFrom and dateTo parameters to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other parameters to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date parameter
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the date for the query string
                                    var dateFrom =
                                        'FromDateLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append the formatted dateFrom to the query string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle the 'end' date parameter
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the date for the query string
                                        var dateTo =
                                            'ToDateLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append the formatted dateTo to the query string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the query string
            string1 = string1 + '&UserId=' + cur_user;
            // Clear the grid data before loading new data
            grid.clearAll();
            // Load the grid with the constructed URL and query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current query string
            filter = string1;
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Set the starting point and count for pagination
                    filter + // Apply any existing filters
                    '&sort[' +
                    by + // Specify the column to sort by
                    ']=' +
                    dir, // Specify the direction of sorting (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item based on its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Attach an event handler for the 'onBeforeEditStart' event of the grid
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Retrieve the item to be edited based on its ID
            console.log(item); // Log the item details for debugging purposes
            if (id.column == 'State') {
                // Check if the edited column is 'State'
                var options = this.getColumnConfig('Action').collection; // Get the collection of options for the 'Action' column
                if (item.State == 'A') {
                    // If the item's state is 'A'
                    options.remove('A'); // Remove 'A' from the options
                } else if (item.State == 'I') {
                    // If the item's state is 'I'
                    options.remove('I'); // Remove 'I' from the options
                } else {
                    return false; // Prevent editing if the state is neither 'A' nor 'I'
                }
                console.log(id); // Log the ID of the item being edited for debugging purposes
            }
        });
        // Attach an event handler for the 'onAfterEditStop' event of the grid
        grid.attachEvent(
            'onAfterEditStop',
            /**
             * Handles the event after editing a cell in the grid.
             * @param {Object} state - The state of the edited cell.
             * @param {Object} editor - The editor object containing information about the edit.
             * @param {boolean} ignoreUpdate - Flag to ignore update.
             */
            function (state, editor, ignoreUpdate) {
                console.log(state); // Log the current state of the edited cell
                var item = this.getItem(editor.row); // Retrieve the item corresponding to the edited row
                console.log(item); // Log the retrieved item
                // Check if the new value is different from the old value
                if (state.value != state.old) {
                    // If the new value is 'A', send a request to allow withdrawal requests
                    if (state.value == 'A') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set the content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', // API endpoint for allowing withdrawal requests
                                '{ "Id":' + item.Id + '}', // JSON payload with the item ID
                                {
                                    // Callback for handling errors
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error! ')); // Display an error message
                                    },
                                    // Callback for handling successful requests
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'P'; // Update the item's state to 'P'
                                        webix.message('Cell value was changed'); // Notify the user of the change
                                    },
                                },
                            );
                    }
                    // If the new value is 'P', send a request to pay withdrawal requests
                    if (state.value == 'P') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set the content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/PayWithdrawalRequests', // API endpoint for paying withdrawal requests
                                '{ "Id":' + item.Id + '}', // JSON payload with the item ID
                                {
                                    // Callback for handling errors
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error! ')); // Display an error message
                                    },
                                    // Callback for handling successful requests
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'I'; // Update the item's state to 'I'
                                        webix.message('Cell value was changed'); // Notify the user of the change
                                    },
                                },
                            );
                    }
                    // If the new value is 'E', send a request to cancel client requests
                    if (state.value == 'E') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set the content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/CancelClientRequests', // API endpoint for canceling client requests
                                '{ "Id":' + item.Id + '}', // JSON payload with the item ID
                                {
                                    // Callback for handling errors
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error! ')); // Display an error message
                                    },
                                    // Callback for handling successful requests
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'E'; // Update the item's state to 'E'
                                        webix.message('Cell value was changed'); // Notify the user of the change
                                    },
                                },
                            );
                    }
                }
            },
        );
        // Listen for the 'player:select' event on the app instance
        this.on(this.app, 'player:select', (id) => {
            // Load grid data with specified parameters including the selected player ID
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id);
        });

        // Create a modal window for editing a token
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'edittokenLocal', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Proveedor') }, // Label for editing provider
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close',
                        click: function () {
                            // Hide the window when the icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'editform', // Unique identifier for the form
                elements: [
                    {
                        view: 'text', // Text input for date
                        label: _('Fecha'), // Label for the date field
                        name: 'Date', // Name of the field
                        readonly: true, // Make the field read-only
                    },
                    {
                        view: 'text', // Text input for user
                        label: _('Usuario'), // Label for the user field
                        name: 'User', // Name of the field
                        readonly: true, // Make the field read-only
                    },
                    {
                        view: 'combo', // Combo box for type selection
                        label: _('Tipo'), // Label for the type field
                        name: 'Type', // Name of the field
                        options: [
                            { id: '0', value: _('Local') }, // Option for Local type
                            { id: '2', value: _('Box') }, // Option for Box type
                        ],
                        readonly: true, // Make the field read-only
                    },
                    {
                        view: 'combo', // Combo box for state selection
                        label: _('Estado'), // Label for the state field
                        name: 'State', // Name of the field
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for Activated state
                            { id: 'E', value: _('Expirado') }, // Option for Expired state
                        ],
                    },
                    { view: 'text', label: _('Codigo'), name: 'Token' }, // Text input for token code
                    {
                        cols: [
                            // Define a layout with columns for buttons
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Hide the window when the button is clicked
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Specify button type as form
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Get values from the form
                                    var values = $$('editform').getValues();
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for saving user security token
                                                'UserManagement/SaveUserSecurityTokenCustom',
                                            values, // Data to be sent in the request
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Show error message on failure
                                                    webix.message('Error! ');
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Show success message on success
                                                    webix.message('Cell value was changed');
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + // Reload the grid with updated data
                                                            '?start=0&count=' +
                                                            grid.data.$pagesize +
                                                            filter,
                                                    );
                                                },
                                            },
                                        );
                                    // Reset the form values to clean state
                                    $$('editform').setValues($$('editform').getCleanValues());
                                    // Hide the window after saving
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Attach a double-click event handler to the grid
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Retrieve the item associated with the clicked ID
            var item = this.getItem(id);
            // Show the popup when an item is double-clicked
            popup.show();
        });

        // Bind the edit form to the data table for data manipulation
        $$('editform').bind($$('datatable')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
